import { For, Show, createEffect, createSignal } from 'solid-js';
import clsx from 'clsx';
import { ErrorCatcher } from '../../tools/error-catcher';
import { ReadMoreItem } from './read-more-item/read-more-item';
import { ImageWordpress } from '../../types/shared';
import { useAppContext } from '../../app-context-provider/app-context-provider';
import { GET_POSTS_QUERY_WITH_TYPE_FILTER } from '../blog-archive/blog-archive-queries';

export type ReadMoreProps = {
    selectedPosts: {
        post_title: string;
        featured_image: ImageWordpress;
        preamble: string;
        permalink: string;
    }[];
    categories: {
        name: string;
        id: number;
        slug: string;
    }[];
    currentPost: number;
    postType: string;
    index: number;
    blockName: string;
    hash: string;
};


export const ReadMore = (componentProps: ReadMoreProps) => {
    // return null;
    const { createCachedResource } = useAppContext();
    const [contentToUse, setContentToUse] = createSignal<any>([]);
    const [contentFromCategories, setContentFromCategories] = createSignal<any>([]);
    const initialQueryVars = () => {
        if (componentProps.categories?.length > 0) {
            return {
                type: componentProps.postType,
                tags: componentProps.categories.map(x => x.slug),
                limit: 6,
                offset: 0,
            };
        }
        return undefined;
    };
    const [queryVars] = createSignal(initialQueryVars());

    const [postsContent] = createCachedResource(
        GET_POSTS_QUERY_WITH_TYPE_FILTER,
        () => queryVars(), // reactive params
        true
    );

    createEffect(() => {
        if (componentProps.selectedPosts?.length > 0) {
            setContentToUse(componentProps.selectedPosts);
        }

    });

    createEffect(() => {
        if (postsContent()) {
            const filteredPostsTemp = postsContent()?.posts.filter(
                (post: any) => post.content.id !== componentProps.currentPost
            );
            const random3Posts = filteredPostsTemp.sort(() => 0.5 - Math.random()).slice(0, 3);
            setContentFromCategories(random3Posts);
        }
    });

    const loadingClasses = clsx('min-h-[20rem]');

    return (
        <ErrorCatcher componentName="ReadMoreArticles">
            <Show
                when={contentFromCategories()?.length > 0}
            >
                <section class="post-list gap-y-s gap-x-m grid grid-cols-1 mobile:grid-cols-2 bigTablet:grid-cols-3">
                    <For each={contentFromCategories()}>
                        {(post) => (
                            <article class="mb-xl">
                                <ReadMoreItem
                                    permalink={post.content.permalink}
                                    postTitle={post.content.post_title}
                                    preamble={post.content.preamble}
                                    featuredImage={post.content.featured_image}
                                />
                            </article>
                        )}
                    </For>
                </section>
            </Show>
            <Show
                when={contentToUse()}
            >
                <section class="post-list gap-y-s gap-x-m grid grid-cols-1 mobile:grid-cols-2 bigTablet:grid-cols-3">
                    <For each={contentToUse()}>
                        {(post) => (
                            <div>
                                <article class="mb-xl">
                                    <ReadMoreItem
                                        permalink={post.permalink}
                                        postTitle={post.post_title}
                                        preamble={post.preamble}
                                        featuredImage={post.featured_image}
                                    />
                                </article>
                            </div>
                        )}
                    </For>
                </section>
            </Show>
        </ErrorCatcher>
    );
};

export default ReadMore;
